const LOGO_HEIGHT = 50;

export { LOGO_HEIGHT };
